import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export type MessageNode = {
  role: string;
  content: {
    text: string;
  }[];
};

export type MappingNode = {
  id: string;
  parent: string | null;
  children: string[];
  message: MessageNode;
};

export type ConversationMapping = Record<string, MappingNode>;
export type Conversation = {
  id: number;
  title: string;
  createdAt: Dayjs;
  updatedAt: Dayjs;
  mapping: ConversationMapping;
  lastMessageId: string;
};
export type PartialConversation = {
  id: number;
  title: string;
  createdAt: Dayjs;
  updatedAt: Dayjs;
};

export interface ConversationsMixin {
  fetch(path: string, init?: RequestInit): Promise<any>;
  conversationsList(sessionId: number): Promise<PartialConversation[]>;
  conversationsGet(sessionId: number, id: number): Promise<Conversation>;
  conversationsCreate(sessionId: number, query: string): Promise<any>;
  messagesCreate(
    sessionId: number,
    conversationId: number,
    parentId: string,
    query: string
  ): Promise<any>;
  conversationsDestroy(id: number): Promise<undefined>;
}
export const ConversationsMixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },
  async conversationsList(sessionId: number): Promise<Conversation[]> {
    const conversations = await this.fetch(`/sessions/${sessionId}/conversations`);
    for (let conversation of conversations) {
      conversation.createdAt = dayjs(conversation.createdAt);
      conversation.updatedAt = dayjs(conversation.updatedAt);
    }
    return conversations;
  },
  async conversationsGet(sessionId: number, id: number): Promise<Conversation> {
    const conv = (await this.fetch(`/sessions/${sessionId}/conversations/` + id)) as Conversation;
    conv.createdAt = dayjs(conv.createdAt);
    conv.updatedAt = dayjs(conv.updatedAt);
    return conv;
  },
  async conversationsCreate(sessionId: number, query: string) {
    return await this.fetch(`/sessions/${sessionId}/conversations`, {
      method: 'post',
      body: JSON.stringify({
        query,
      }),
    });
  },
  async messagesCreate(sessionId: number, conversationId: number, parentId: string, query: string) {
    return await this.fetch(`/sessions/${sessionId}/conversations/${conversationId}/messages`, {
      method: 'post',
      body: JSON.stringify({
        parentId,
        query,
      }),
    });
  },
  async conversationsDestroy(id: number): Promise<undefined> {
    await this.fetch('/conversations/' + id, {
      method: 'DELETE',
    });
  },
} as ConversationsMixin;
